(function () {
  var ADD_TO_CART_SELECTOR = '.product-add';
  var QUICK_VIEW_SELECTOR = '.quick-buy';
  var OPTION_SELECTOR = '.single-option-selector';
  var VARIANT_SELECTOR = '[name="id"]';
  var POPUP_ID = 'purchaseAlertPopup';
  var QUANTITY_SELECTOR = '[name="quantity"]';
 
  var cartData = {};
  var wsProduct = window.wsProduct || {};
  var currentVariantData = {};
  var addBtn, page, form;

  var settings = {
    same_product: {
      enabled: true,
      text: "*** Hey there! Looks like you are trying to add multiples of the same item to your cart. If you do want to order more than 1, go ahead and click Add to Cart below. Otherwise, pick a different option or just click close."
    }
  };

  function getPageType ()
  {
    var urlParts = window.location.pathname.split('/');

    if (urlParts.indexOf('products') !== -1) {
      return 'products';
    } else {
      return urlParts[1] || 'index';
    }
  }

  function addToCart ()
  {
    addBtn.removeAttribute('disabled');
    addBtn.setAttribute('disable-alert', true);
    $(addBtn).trigger('click', [true]);
    $.colorbox.close();
  }
  
  function getPopupElement (text)
  {
      var $template = $('<div class="popup-alert-container">'+ text +'</div>');
      var $controls = $('<div class="controls-container"></div>');
      var $closeBtn = $('<button id="closeBtn">Close</button>');
      var $addToCart = $('<button class="add-btn" id="addToCart">Add to Cart</button>');
      $controls.append($addToCart);
      $controls.append($closeBtn);
      
    
      var colorboxSettings = {
        closeButton: false,
        escKey: false,
        overlayClose: false,
        height: 'auto',
        width: (window.document.body.clientWidth > 600) ? 600 : window.document.body.clientWidth,
        preloading: false,
      	open: true,
      	speed: 200,
      	html: ['<div class="action-icons">',
               '<a href="#" class="close-box action-icon">'+theme.icons.close+'</a>',
               '</div>',
               '<div id="hidden-form"></div>',
               $template.wrap('<div>').parent().html(),
               $controls.wrap('<div>').parent().html()].join(''),
      };
    
      $.colorbox(colorboxSettings);
  }

  function showAlertPopup (text)
  {
    getPopupElement(text);
    
    var closeBtn = document.getElementById('closeBtn');
    closeBtn.onclick = function() {
    	$.colorbox.close();
    };
    
    var addCart = document.getElementById('addToCart');
    addCart.onclick = addToCart;
    addBtn.removeAttribute('disabled');
    
    var hiddenForm = document.getElementById('hidden-form');
    if (page !== 'products') {
      $('#hidden-form').append(form);
    }
  }

  function getCurrentQuantity () {
    form = $(addBtn).closest('form.product-form');
    var quantitySelector = form.find(QUANTITY_SELECTOR).val();
    return (quantitySelector !== null) ? parseInt(quantitySelector) : 1;
  }

  function processAlerts(variant, cart)
  {
    for (var i = 0; i < cart.items.length; i++) {
      if (settings.same_product.enabled) {
        if (settings.same_product.enabled &&
          variant == cart.items[i].id) {
          showAlertPopup(settings.same_product.text);
          return true;
        }
      }
    }

    return false;
  }

  function runAlerts (e, standardAction)
  {
    if (!settings.same_product.enabled) {
      return; 
    }    
    
    var vid = $(this).closest('form.product-form').find(VARIANT_SELECTOR).val();
    if(vid){
    	currentVariantData = parseInt(vid);
    }    
    
    if (!this.getAttribute('disable-alert') && !standardAction) {
      e.stopPropagation();
      e.preventDefault();

      if (settings.same_product.enabled && getCurrentQuantity() > 1) {
        showAlertPopup(settings.same_product.text);
        return;
      }

      this.setAttribute('disabled', 'disabled');      

      $.ajax({
        url: '/cart?view=json',
        type: 'GET',
        success: function (response) {
          try {
            cartData = JSON.parse(response);
            if (typeof cartData.items === 'undefined' || !processAlerts(currentVariantData, cartData)) {
              addBtn.removeAttribute('disabled');
              $(addBtn).trigger('click', [true]);
            }
          } catch (e) {
            addToCart();
          }
        },
        error: function () {
          addBtn.removeAttribute('disabled');
          $(addBtn).trigger('click', [true]);
          throw new Error('Unable to retrieve cart data');
        }
      });
    } else {
      return true;
    }
  }

  function runProduct (addBtnSelector, interval)
  {
    setTimeout(function () {
      addBtn = document.querySelector(addBtnSelector);
      if (addBtn === null) {
        throw new Error('Add to cart button was not found');
      } else {
        addBtn.onclick = runAlerts;
      }
    }, interval || 0);
  }

  function runCollection ()
  {
    quickViewBtns = document.querySelectorAll(QUICK_VIEW_SELECTOR);
    $(quickViewBtns).click(function () {
      $.getJSON(this.href + '.js', function (product) {
        if (product) {
          wsProduct = product;
          runProduct(ADD_TO_CART_SELECTOR, 500);
        } else {
          throw new Error('Invalid product');
        }
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function ()
  {
    page = getPageType();

	if (settings.same_product.enabled) {
      if (page === 'products') {
        runProduct(ADD_TO_CART_SELECTOR, 200);
      } else if (['collections', 'search', 'index'].indexOf(page) !== -1) {
        selectorPrefix = '';
        runCollection();
      }
  	}
  });
})();